__webpack_require__.p = "/elections/campaign-details/";